import AccessDeniedPage from 'pages/access-denied';
import AppUsersPage from 'pages/appUsers';
import CatalogPage from 'pages/catalog';
import CountriesPage from 'pages/countries';
import ExpiredSessionPage from 'pages/expired-session';
import ExpiredTokenPage from 'pages/expired-token';
import NotFoundPage from 'pages/general/not-found-page';
import GpoOrdersPage from 'pages/gpo-orders';
import InquiryProcessorPage from 'pages/inquiry-processor';
import LoginPage from 'pages/login';
import NotificationProvidersPage from 'pages/notification-providers';
import OrdersPage from 'pages/orders';
import PricesPage from 'pages/prices';
import ProfilePage from 'pages/profile';
import ReconciliationPage from 'pages/reconciliation';
import RestaurantsPage from 'pages/restaurants';
import SalesLookupPage from 'pages/sales-lookup';
import SmsOtpPage from 'pages/sms-otp';
import SupplierProfilesPage from 'pages/supplier-profiles';
import SuppliersPage from 'pages/suppliers';
import UnmatchedDemandPage from 'pages/unmatched-demand';
import UserManagementPage from 'pages/user-management';
import ValidationCodePage from 'pages/validation-code';
import { RouteProps } from 'react-router-dom';
// import { ability } from '../configs/ability';

// A.C: Routes after user logged in only
export const privateRoutes: RouteProps[] = [
  {
    path: '/app/user-management',
    component: UserManagementPage,
  },
  {
    path: '/app/Profile',
    component: ProfilePage,
  },
  {
    path: '/app/restaurants',
    component: RestaurantsPage,
  },
  {
    path: '/app/catalog',
    component: CatalogPage,
  },
  {
    path: '/app/suppliers',
    component: SuppliersPage,
  },
  {
    path: '/app/app-users',
    component: AppUsersPage,
  },
  {
    path: '/app/orders',
    component: OrdersPage,
  },
  {
    path: '/app/prices',
    component: PricesPage,
  },
  {
    path: '/app/sales-lookup',
    component: SalesLookupPage,
  },
  {
    path: '/app/supplier-profiles',
    component: SupplierProfilesPage,
  },
  {
    path: '/app/reconciliation',
    component: ReconciliationPage,
  },
  {
    path: '/app/gpo-orders',
    component: GpoOrdersPage,
  },
  {
    path: '/app/inquiry-processor',
    component: InquiryProcessorPage,
  },
  {
    path: '/app/sms-otp',
    component: SmsOtpPage,
  },
  {
    path: '/app/countries',
    component: CountriesPage,
  },
  {
    path: '/app/unmatched-demand',
    component: UnmatchedDemandPage,
  },
  {
    path: '/app/notification-providers',
    component: NotificationProvidersPage,
  },
];

// A.C: Routes before user logged in only
export const preLoginRoutes: RouteProps[] = [
  {
    path: '/login',
    component: LoginPage,
  },
  {
    path: '/validation-code',
    component: ValidationCodePage,
  },
];

// A.C: Routes for both logged in/out
export const publicRoutes: RouteProps[] = [
  {
    path: '/access-denied',
    component: AccessDeniedPage,
  },
  {
    path: '/expired-token',
    component: ExpiredTokenPage,
  },
  {
    path: '/expired-session',
    component: ExpiredSessionPage,
  },
  {
    path: '/404',
    component: NotFoundPage,
  },
];
